import React from 'react'
import { Accordion } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


class AccordionComponent extends React.Component {

    render() {
        return (

            <Accordion defaultActiveKey={[this.props.default_key] ?? null} flush>
                {
                    this.props.data.map((row, key) => (

                        <Accordion.Item eventKey={key}>
                            <Accordion.Header>
                                <strong>{ row.icon && <FontAwesomeIcon icon={ row.icon } /> } { row.title }</strong>
                            </Accordion.Header>
                            <Accordion.Body style={{ background: '#FFF' }}>
                                {row.body}
                            </Accordion.Body>
                        </Accordion.Item>

                    ))
                }
            </Accordion>

        )
    }

}

export default AccordionComponent;